<template>
  <div class="quantity-input" v-bind:class="classes" :class="{ disabled: disabled, small: small }">
    <button @click.stop="decrease" @click.right.stop class="action" :disabled="disabled">–</button>
    <input class="pt-[2px]" :min="minValue" :max="maxValue" type="number" :value="quantity" @change="update" :class="{'text--primary font-weight-bold': changed}"
           :disabled="disabled" @click.stop>
    <button @click.stop="increase" @click.right.stop class="action" :disabled="disabled">+</button>
  </div>
</template>

<style scoped>
.v-alert {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.v-card-text {
  padding-left: 0 !important;
}

.v-card-actions {
  padding: 0;
}
</style>
<script>

import {debounce} from "lodash";

export default {
  name: "QuantityInput",
  emits: ['input'],
  props: {
    value: {
      Type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: "",
    },
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 999,
    },
    changed: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      count: this.value,
      show: false,
      emitDebounced: debounce((val) => {
        this.$emit('input', val)
      }, 0)
    }
  },
  computed: {
    quantity: {
      get() {
        return this.count
      },
      set(value) {
        this.count = value
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(newValue) {
      this.count = newValue
    }
  },
  methods: {
    increase() {
      if (this.disabled) return;
      if (this.quantity == this.maxValue) {
        return;
      }
      this.quantity++
    },

    decrease() {
      if (this.disabled) return;
      if (this.quantity == this.minValue) {
        return;
      }
      this.quantity--
    },

    update(e) {
      if (this.disabled) return;
      this.quantity = +e.target.value
    },
  }
}

</script>

<style lang="scss">
@import '@/scss/settings/color';

.quantity-input {
  max-width: 105px;
  display: grid;
  grid-template-columns: 2rem minmax(2rem, 4rem) 2rem;
  border: 1px solid rgba(0, 0, 0, 0.42);
  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  border-radius: 10px;

  &.small {
    border: none;

    .action {
      padding: 2px 9px;
    }
  }

  &:hover, &:focus {
    border-color: black;
  }

  input {
    position: relative;
    top: 1px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .action {
    padding: 8px 9px;
    cursor: pointer;
    font-size: 24px;
    line-height: 22px;

    &:hover {
      color: $color-primary;
    }

    &:focus {
      outline: none;
      color: $color-primary;
    }
  }

  input {
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    background-color: transparent;

    &:focus {
      outline: none;
      color: $color-primary;
      font-weight: bold;
    }
  }

  &.disabled {
    opacity: 0.4;

    .action {
      cursor: default;
    }
  }
}

</style>
